import "./components/filters";
import "./components/menu";
import "./components/landing";
import "./components/horizontal-scroll";
import "./components/artists-in-residence";
import "./components/news-filter";
import "./components/job";
